import { useMemo } from "react";
import Dropdown from "./Dropdown";

const DropDownDepartment = ({
  value,
  onChange,
  options = [],
  optionsValue = [],
  disabled = false,
}) => {
  const mappedOptions = useMemo(() => {
    const len = Math.min(options.length, optionsValue.length);
    return Array.from({ length: len }).map((_, idx) => ({
      label: options[idx],
      value: optionsValue[idx],
    }));
  }, [options, optionsValue]);

  return (
    <Dropdown
      variant="select"
      id="department-select"
      value={value}
      onChange={onChange}
      options={mappedOptions}
      placeholderKey="dropdown.department"
      disabled={disabled}
    />
  );
};

export default DropDownDepartment;
